import classNames from 'classnames';
import React from 'react';
import { tp } from '@/shared/lib/typograf';
import Button from '../../shared/Button/Button';
import Link from '../../shared/Link';

export type StagesSectionProps = {
    title: string;
    button?: {
        text: string;
        href: string;
    };
    stages: {
        title: string;
        contentItems: {
            label: string;
            text: string;
        }[];
        label?: string | null;
        status?: string | null;
    }[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    stagesSectionProps: StagesSectionProps;
};

const StagesSection = ({ stagesSectionProps, className, ...props }: Props) => {
    const { title, button, stages } = stagesSectionProps;

    return (
        <section className={classNames('stages-section', className)} {...props}>
            <div className="wrapper stages-section__wrapper">
                <div className="stages-section__top">
                    <h2 className="stages-section__title h3" dangerouslySetInnerHTML={{ __html: tp(title) }}></h2>
                    {button && (
                        <Button tag={Link} href={button.href} variant="outline-dark" className="stages-section__button">
                            {button.text}
                        </Button>
                    )}
                </div>

                {stages.length > 0 && (
                    <ul className="list-unstyled stages-section__list">
                        {stages.map((stage, i) => (
                            <li key={i} className="stages-section__card stage-card">
                                <div className="stage-card__content">
                                    <div
                                        className="stage-card__title"
                                        dangerouslySetInnerHTML={{ __html: tp(stage.title) }}
                                    ></div>
                                    {stage.contentItems.length > 0 && (
                                        <div className="stage-card__items">
                                            {stage.contentItems.map((item, j) => (
                                                <div key={j} className="stage-card__item">
                                                    <span className="stage-card__item-label text-s">{item.label}</span>
                                                    <div
                                                        className="stage-card__item-text text-s wysiwyg"
                                                        dangerouslySetInnerHTML={{ __html: tp(item.text) }}
                                                    ></div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="stage-card__header">
                                    {stage.status && (
                                        <div className="stage-card__status status-badge">
                                            <span className="status-badge__text text-xs">{stage.status}</span>
                                        </div>
                                    )}
                                    {stage.label && <span className="stage-card__label h2">{stage.label}</span>}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </section>
    );
};

export default StagesSection;
